export default {
  data () {
    return {
      visibility: false
    }
  },
  methods: {
    //时间戳转成日期
    formatDate (time, type) {
      if (isNaN(time) || time == null || time == '' || time == undefined) {
        return '';
      }
      var tmpDate = new Date(parseInt(time));
      var year = tmpDate.getFullYear();
      var month = this.addZero(tmpDate.getMonth() + 1);
      var day = this.addZero(tmpDate.getDate());
      var hours = this.addZero(tmpDate.getHours());
      var minutes = this.addZero(tmpDate.getMinutes());
      var seconds = this.addZero(tmpDate.getSeconds());
      if (type == 'yyyy年mm月dd日') {
        return year + '年' + month + '月' + day + '日';
      } else if (type == 'yyyy-mm-dd') {
        return year + '-' + month + '-' + day;
      } else if (type == 'yyyy-mm') {
        return year + '-' + month;
      } else if (type == 'hh:mm:ss') {
        return hours + ':' + minutes + ':' + seconds;
      } else if (type == 'hh:mm') {
        return hours + ':' + minutes;
      } else if (type == 'yyyy-mm-dd hh:ss') {
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
      } else {
        return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
      }
    },
    addZero (time) {
      var d = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09']
      if (parseInt(time) < 10) {
        return d[time]
      } else {
        return time
      }
    },
    //去除数组重复项，用一个hashtable的结构记录已有的元素，这样就可以避免内层循环。
    arrayUnique (arr) {
      var result = [], hash = {};
      for (var i = 0, elem; (elem = arr[i]) != null; i++) {
        if (!hash[elem]) {
          result.push(elem);
          hash[elem] = true;
        }
      }
      return result;
    },
    //获取URL路由上面的参数
    getQueryString (paramName) {
      var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
      return null;
    },
    //验证权限的方法
    authValidate (value) {
      var authArray = YJ_SCHOOL_STORAGE.getItem('authArray') ? JSON.parse(YJ_SCHOOL_STORAGE.getItem('authArray')) : [];
      return authArray.indexOf(value) > -1;
    },
    deleteUseModel () {
      const mathRandom = Math.random();
      this.$dispatch('delete:sure', mathRandom);
      this.$once('delete:sure', random => {
        if (random === mathRandom) {
          this.$emit('delete:start', mathRandom);
          this.$off('delete:start');
          this.$off('delete:cancel');
        }
      });

      this.$once('delete:cancel', random => {
        if (random === mathRandom) {
          this.$off('delete:start');
          this.$off('delete:sure');
        }
      });

      return mathRandom;
    },
    getDictionaryList (sysDicType) {
      return this.$http.post({
        url: `/marking/dispatcher.do`,
        method: 'POST',
        data: {
          dispatcher: 200,
          _platform: 'pc',
          type: 2,
          sysDicType: sysDicType
        }
      }).then(res => {
        const result = res.data.obj;
        return result;
      });
    },
    /**
     * toast 方法
     * @param type
     * @param message
     */
    toast (message, type) {
      if (message == "学科主键列表不能为空") {
        message = "请选择学科"
      }
      this.$notify({
        message: message,
        type: type
      });
    },
    /**
     * 获取用户信息
     * @returns {userInfo|{roles}|{}|*}
     */
    getUserInfo () {
      return this.$root.userInfo;
    },
    /**
     * 获取业主信息
     * @returns {*}
     */
    getSocial () {
      return this.$root.social;
    },
    getBaseImgUrl () {
      return 'http://img.kingsum.biz:81'
    },
    //图片的前缀地址
    getImgUrl () {
      return '';
    },
    // getwxQRcode(){
    //   return wxQrcode;
    // },
    baseUrl () {
      return '';
    },
    basePreviewUrl () {
      return 'http:/www.beejy.com:8890/marking';
    },
    // baseDownUrl(){
    //   return backendUrl+'/marking/dispatcher.do';
    // },
    // baseDownLoadUrl(){
    //   return backendUrl+'/';
    // },
    isIphone () {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("Safari") > -1) {
        return false;
      }
      return true;
    },
    fixUrl: function (url) {
      if (url) {
        const infos = url.split('://')
        if (infos.length > 1) {
          return infos[0] + '://' + infos[1].replace(/\/\//g, '\/')
        } else {
          return url.replace(/\/\//g, '\/')
        }
      } else {
        return url
      }
    },
    getOssUrl: function (url) {
      return 'https://' + process.env.VUE_APP_OSS_BUCKET + '.' + url
    },
    getCourseId: function (code) {
      const subjectCode = code + ''
      const courseId = subjectCode.substring(subjectCode.length - 3)
      return isNaN(courseId) ? code : parseInt(courseId)
    },
    getPanduanTiOpt: function (type, subjectCode, isRed) {
      // 除了英语是T和F，否则都是√和×
      const isYingYu = ['28', '12', '3'].indexOf(subjectCode + '') >= 0
      if (type === 'T') {
        if (isYingYu) {
          return 'T'
        } else {
          const src = require('@/v3/modules/card/assets/images/card-right' + (isRed ? '-red' : '') + '.png')
          return '<img src=' + src + ' style="position: absolute;top: 2px;height: 7px; left: 6px;" />'
        }
      } else {
        if (isYingYu) {
          return 'F'
        } else {
          const src = require('@/v3/modules/card/assets/images/card-wrong' + (isRed ? '-red' : '') + '.png')
          return '<img src=' + src + ' style="position: absolute;top: 3px;height:6px; left: 8px;" />'
        }
      }
    },
    //计算拼接题号
    getNums (val) {
      for (let item of val) {
        let res = ''
        const list = item.list || item.stands || []
        for (let num of list) {
          if (num.examId !== this.examId) {
            let no = ''
            if (num.bigNum && num.smallNum) {
              no += num.bigNum + '.' + num.smallNum + '、'
            } else {
              no += num.question + '、'
            }
            res += '<span style="color: #447ed9">' + no + '</span>'
          } else {
            if (num.bigNum && num.smallNum) {
              res += num.bigNum + '.' + num.smallNum + '、'
            } else {
              res += num.question + '、'
            }
          }
        }
        res = res.substring(0, res.lastIndexOf('、'))
        item.nums = res
      }
    },
    //计算拼接题号
    getNumsNoList (val) {
      for (let item of val) {
        if (item.bigNum && item.smallNum) {
          item.nums = item.bigNum + '.' + item.smallNum
        } else {
          item.nums = item.question + ' '
        }
      }
    }
  }
}